<template>
  <el-form class="ai-lesson-entity-form">
    <component :is="entity_type" :form="form"/>
    <el-form-item label="进入消息">
      <el-input v-model="form.enter_msg" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
    </el-form-item>
<!--    <el-form-item label="提示用户是否需要准备">-->
<!--      <div class="inline-block w100">-->
<!--        <el-radio-group v-model="form.enter_ready">-->
<!--          <el-radio-button :label="0">不需要</el-radio-button>-->
<!--          <el-radio-button :label="1">需要</el-radio-button>-->
<!--        </el-radio-group>-->
<!--      </div>-->
<!--    </el-form-item>-->
    <el-form-item label="GPT第一句话">
      <el-input v-model="form.first_msg" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
    </el-form-item>
    <el-form-item label="下一个消息">
      <el-input v-model="form.next_msg" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
    </el-form-item>
    <el-form-item label="完成模块消息">
      <el-input v-model="form.finish_msg" type="textarea" resize="none" :autosize="{minRows:1}"></el-input>
    </el-form-item>
    <el-form-item label="STT语音转文本字符替换">
      <SttFormat v-model="form.stt_format"></SttFormat>
      <div class="form-item-hint" style="color:#909399;">
        示例: 当发送内容匹配: <span class="text-underline">丽丽</span> &nbsp;&nbsp; 将用户的语音文本: <span class="text-underline">[莉丽利]{2}</span> &nbsp;&nbsp; 替换为: <span class="text-underline">丽丽</span>
      </div>
    </el-form-item>
    <el-form-item label="TTS文本转语音字符替换">
      <TtsFormat v-model="form.tts_format"></TtsFormat>
      <div class="form-item-hint" style="color:#909399;">
        示例: 当发送内容匹配: <span class="text-underline">请用.还.造一个句子</span> &nbsp;&nbsp; 将: <span class="text-underline">还</span> &nbsp;&nbsp; 替换为: <span class="text-underline">还hai2</span>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
import ai_rpg from "./ai_rpg_form.vue";
import ai_rc from "./ai_rc_form.vue";
import ai_qa from "./ai_qa_form.vue";
import ai_topic from "./ai_topic_form.vue";
import ai_words from "./ai_words_form.vue";
import ai_kewen from "./ai_kewen_form.vue";
import ai_word_trans from "./ai_word_trans_form.vue";
import ai_word_sentence from "./ai_word_sentence_form.vue";
import ai_sentence_order from "./ai_sentence_order_form.vue";
import ai_sentence_trans from "./ai_sentence_trans_form.vue";
import {cloneDeep} from 'lodash';
import SttFormat from "./stt_format_form.vue";
import TtsFormat from "./tts_format_form.vue";
export default {
  name: "ai_form",
  components: {SttFormat, TtsFormat, ai_rpg, ai_rc, ai_qa, ai_topic, ai_words, ai_kewen, ai_word_trans, ai_word_sentence, ai_sentence_order, ai_sentence_trans},
  data() {
    return {
      id: 0,
      entity_type: '',
      form: {
        entity_id: 0,
        enter_msg: '',
        enter_ready: 0,
        first_msg: '',
        next_msg: '',
        finish_msg: '',
        stt_format: [{}],
        tts_format: [{}],
      }
    }
  },
  methods: {
    reset(model) {
      this.id = model.id;
      this.form = cloneDeep(Object.assign({
        enter_msg: '',
        enter_ready: 0,
        first_msg: '',
        next_msg: '',
        finish_msg: '',
        entity_id: model.entity_id,
        stt_format: [{}],
        tts_format: [{}],
      }, model.entity_data))
      this.entity_type = model.entity_type;
    },
    submit() {
      if (!this.id) {
        return Promise.reject('');
      }
      const {entity_id, stt_format, tts_format, ...data} = this.form;
      if (stt_format) {
        const formats = stt_format.filter(n => n.pattern);
        if (formats.length > 0) {
          data.stt_format = formats;
        }
      }
      if (tts_format) {
        const formats = tts_format.filter(n => n.pattern);
        if (formats.length > 0) {
          data.tts_format = formats;
        }
      }
      return this.$http.put(this.$urls.lesson_entity_update, {
        entity_id,
        data
      }, {
        params: {id: this.id}
      });
    }
  }
}
</script>

<style lang="scss">
.ai-lesson-entity-form {
  .el-form-item__label {
    line-height: 1.2;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
  .ai-items {
    margin-bottom: 20px;
    .ai-item-wrap {
      display: inline-block;
      width: 100%;
      margin-top: 8px;
    }
    .ai-item {
      display: flex;
      > * {
        margin-left: 8px;
        margin-right: 0;
      }
      > *:first-child {
        margin-left: 0;
      }
      .el-input {
        flex: 1;
      }
      .ai-item-no {
        flex: none;
        width: 120px;
      }
      .el-button{
        width: 40px;
        height: 40px;
        padding: 0;
        line-height: 40px;
        text-align: center;
      }
    }
  }
  .mb0 {
    margin-bottom: 0;
  }
  .hover-ctl {
    position: relative;
    .hover-content {
      display: none;
      position: absolute;
      left: 0;
      bottom: 20px;
    }
    &:hover .hover-content {
      display: block;
    }
  }
}
</style>